import { Link } from "react-router-dom";
import Disclaimer from "../../components/Disclaimer/Disclaimer";
import Layout from "../../components/Layout/Layout";

const About = () => {
  return (
    <Layout>
      <section className="max-w-3xl mx-auto px-6 py-16 w-full">
        <p className="text-sun font-semibold uppercase tracking-wide text-sm">
          A project of Earthbound Martian
        </p>
        <h1 className="text-5xl font-bold text-alt-blk mt-3">About RenCamp</h1>
        <p className="text-xl text-alt-blk/80 mt-6 leading-relaxed">
          Plan renaissance faires, historical festivals, fairy fests, mermaid
          meets, and pirate weekends as actual trips. This is a practical, free
          tool for people who want dates, a pin on the map, and a note on
          whether they can sleep on site or nearby.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">What v1 is</h2>
        <p className="leading-relaxed mb-4">
          A map of the US and Canada, a modest curated list, and a calendar of
          seasons. Useful first. Promotional second. Texas is on the list
          because the faires are good — not because the map stops at the state
          line. Alaska and Canada are on it for the same reason.
        </p>
        <p className="leading-relaxed">
          It is not a ticket shop, a costume encyclopedia, or a complete
          directory of every weekend village in North America. Dark-sky
          overnights live at{" "}
          <a
            href="https://darkskies.earthboundmartian.com"
            className="text-turquoise hover:text-mars"
          >
            Darkskies
          </a>
          .
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Data</h2>
        <Disclaimer />
        <p className="leading-relaxed mt-4">
          Dates are taken from organizer calendars for 2026 where we could
          confirm them. When a run has closed, we project the typical season so
          you can still plan the next year. Place search uses{" "}
          <a
            className="text-turquoise hover:text-mars"
            href="https://photon.komoot.io"
            target="_blank"
            rel="noreferrer"
          >
            Photon
          </a>{" "}
          (OpenStreetMap).
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Camping notes</h2>
        <p className="leading-relaxed">
          “On-site” means the event itself sells or hosts camping. “Nearby”
          means a realistic overnight within a short drive — state parks, RV
          parks, or a known overflow. “Day trip” means hotels or a long same-day
          drive. Pins are not a reservation and not legal advice. Rules change.
        </p>

        <h2 className="text-2xl font-bold mt-12 mb-4">Earthbound Martian</h2>
        <p className="leading-relaxed mb-6">
          RenCamp is built for the same people who want comfortable multi-night
          stays next to a village, a battlefield, or a mermaid parade. If that
          is your kind of work, the Landships are for that kind of work. No hard
          sell — just a door back to the shop.
        </p>
        <div className="flex flex-wrap gap-3">
          <a
            href="https://earthboundmartian.com"
            className="inline-block bg-mars hover:bg-sunset text-white px-8 py-4 rounded-2xl font-semibold"
          >
            Visit Earthbound Martian
          </a>
          <Link
            to="/contact"
            className="inline-block border border-alt-blk px-8 py-4 rounded-2xl font-semibold hover:bg-alt-blk hover:text-white transition-colors"
          >
            Contact
          </Link>
        </div>
      </section>
    </Layout>
  );
};

export default About;
